import * as React from 'react';
import { SVGProps } from 'react';
const TableViewSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.90753 11.9282V12.4282H1.40753H4.22259H4.72259V11.9282V8.40939V7.90939H4.22259H1.40753H0.90753V8.40939V11.9282ZM8.94518 3.48303V2.98303H8.44518H5.63012H5.13012V3.48303V7.00185V7.50185H5.63012H8.44518H8.94518V7.00185V3.48303ZM4.72259 3.48303V2.98303H4.22259H1.40753H0.90753V3.48303V7.00185V7.50185H1.40753H4.22259H4.72259V7.00185V3.48303ZM5.13012 11.9282V12.4282H5.63012H8.44518H8.94518V11.9282V8.40939V7.90939H8.44518H5.63012H5.13012V8.40939V11.9282ZM9.35271 11.9282V12.4282H9.85271H12.5932H13.0932V11.9282V8.40939V7.90939H12.5932H9.85271H9.35271V8.40939V11.9282ZM12.5925 7.50185H13.0925V7.00185V3.48303V2.98303H12.5925H9.85271H9.35271V3.48303V7.00185V7.50185H9.85271H12.5925ZM12.5925 12.8357H1.40753C0.90742 12.8357 0.5 12.4283 0.5 11.9282V2.0755C0.5 1.57539 0.90742 1.16797 1.40753 1.16797H12.5925C13.0926 1.16797 13.5 1.57539 13.5 2.0755V11.9282C13.5 12.4283 13.0926 12.8357 12.5925 12.8357Z"
      fill="#475CB0"
      stroke="#475CB0"
    />
  </svg>
);
export default TableViewSvg;
